import {enumTypes, getEnumLabel} from './enumHelper';

export function getTAskAlertCategoryLabel (category) {
  return category ? (getEnumLabel(enumTypes.SCHEDULER_WARNING_TYPE)(category) || category) : '';
}
